var fowtr_module_chapter_4 = (function (fowtr_module_chapter_4) {


    fowtr_module_chapter_4.popupWorkshopViewed = false;


    fowtr_module_chapter_4.init = function(chapter){
      
      if(fowtr_module_chapter_4.controller){
        // console.log('destroying fowtr_module_chapter_4.controller');
        fowtr_module_chapter_4.controller.destroy(true);
        fowtr_module_chapter_4.controller = null;
      }
      // gsap.killTweensOf("*");
      gsap.globalTimeline.clear();

      // console.log('fowtr_module_chapter_4 initialised');
      
      if(!fowtr_module_utilities.disableFancyStuff) {
        $("#fowtr-chapter4 #fowtr-article1 .fowtr-parallax-bg video").prop('muted', true);
        $("#fowtr-chapter4 #fowtr-article1 .fowtr-parallax-bg video").get(0).play();
      }




      // Video
      var mainVideo = $('#fowtr-chapter4 #fowtr-article1 video');
      // var baseSrc = 'https://dhl-future-of-work-trend-report.fra1.cdn.digitaloceanspaces.com/video/';
      mainVideo.removeAttr('src');
      var baseSrc = mainVideo.attr('data-base-ref') + 'chapter-4-cover-video-';
      if($(window).width() > 1000) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1088.mp4' />");
      } else if($(window).width() > 700) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1920x1088.mp4' />");
      } else if($(window).width() > 400) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"1280x724.mp4' />");
      } else if($(window).width() > 300) {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"852x482.mp4' />");
      } else {
        mainVideo.append("<source type='video/mp4' src='"+baseSrc+"352x198.mp4' />");
      }



      // PARALLAX CONTROLLER
      // duration is 300% - meaning, if will 'do stuff' for 300% of the height - and as they are 100% height, that covers them 'coming in', 'in', and 'going out' of viewport

      fowtr_module_chapter_4.controller = new ScrollMagic.Controller({
        globalSceneOptions: {
          // triggerHook: "onEnter",
          // duration: "300%"
        }});



      if(fowtr_module_utilities.disableFancyStuff) fowtr_module_chapter_4.controller = null;


      // ------------------------------------------------------------------------------------------------------
      // article 1
      // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter4 #fowtr-article1 .fowtr-parallax-bg').css({'top':'auto','bottom':'0','height':'110%',});
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article2", duration: "100%", triggerHook: "onEnter"})
        .setTween("#fowtr-chapter4 #fowtr-article1 > .fowtr-parallax-bg", {y: "50%", opacity:0, ease: Linear.easeNone})
        .addTo(fowtr_module_chapter_4.controller);



      // // ------------------------------------------------------------------------------------------------------
      // // article 4
      // // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter4 #fowtr-article4 .fowtr-parallax-bg').css({
      // //   'height':'120%',
      //   'top':'-45%',
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article4", duration: "200%", triggerHook: "onEnter"})
      //   .setTween("#fowtr-chapter4 #fowtr-article4 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
      //   .addTo(fowtr_module_chapter_4.controller);



      // ------------------------------------------------------------------------------------------------------
      // article 5 - pinning
      // ------------------------------------------------------------------------------------------------------


      // pinning the section
      var article6scene1 = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article5", triggerHook:'onLeave'})
              .setPin("#fowtr-chapter4 #fowtr-article5")
              .on('update', function () {
                // ugly hack to detect if its full header, minimal header, fullscreen etc.
                if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
                  article6scene1.offset(0);
                } else {
                  if($(window).width()<768){
                    article6scene1.offset(-56);
                  } else {
                    article6scene1.offset(-108);
                  }
                }
              })
              .addTo(fowtr_module_chapter_4.controller);

      // animating the cards, first one enlarging
      var tl = new TimelineMax();

      // var pinnedMarginTop = 120; // without secondary nav
      var pinnedMarginTop = 60; // without secondary nav
      // var pinnedMarginTop = 170; // without secondary nav
      
      article6scene1.offset(-108);

      // tl.call(function() { if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) article6scene1.offset(0); }, null, null, 0.1);


      tl.call(function() { $('#fowtr-chapter4 #fowtr-article5').removeClass("pinned"); }, null, null, 0);
      tl.call(function() { $('#fowtr-chapter4 #fowtr-article5').removeClass("pinned"); }, null, null, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 img", 0.5, {opacity:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 img", 0.5, {height:0, display:'none', ease: Linear.easeNone}, 0.5);
      tl.to("#fowtr-chapter4 #fowtr-article5 h4", 1, {marginBottom:15, marginTop:pinnedMarginTop, padding:0, ease: Linear.easeNone}, 0);
      tl.fromTo("#fowtr-chapter4 #fowtr-article5 .card1 .indicator", 1, {borderBottomWidth:"0px"},{borderBottomWidth:"10px", ease: Linear.easeNone}, 0);
      // tl.fromTo("#fowtr-chapter4 #fowtr-article5 h4", 1, {fontSize:"150%"},{fontSize:"120%", ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 .card1 h4, #fowtr-chapter4 #fowtr-article5 a.card1", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 img", 1, {marginBottom:0, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 .card1 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);
      tl.to("#fowtr-chapter4 #fowtr-article5 .card2 .fowtr-black-overlay, #fowtr-chapter4 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl.call(function() { $('#fowtr-chapter4 #fowtr-article5').addClass("pinned"); }, null, null, 2);

      // tl.call(function() { console.log('pinning article 6'); }, null, null, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article5", triggerHook:'onLeave', duration: 300})
        // .setClassToggle("#fowtr-chapter4 #fowtr-article5", "pinned")
        .setTween(tl)
        .addTo(fowtr_module_chapter_4.controller);



      // animating the cards, second one enlarging


      var tl2 = new TimelineMax();

      tl2.to("#fowtr-chapter4 #fowtr-article5 .card1 h4, #fowtr-chapter4 #fowtr-article5 .card3 h4, #fowtr-chapter4 #fowtr-article5 a.card1, #fowtr-chapter4 #fowtr-article5 a.card3", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter4 #fowtr-article5 .card2 h4, #fowtr-chapter4 #fowtr-article5 a.card2", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter4 #fowtr-article5 .card1 .indicator, #fowtr-chapter4 #fowtr-article5 .card3 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter4 #fowtr-article5 .card2 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl2.to("#fowtr-chapter4 #fowtr-article5 .card1 .fowtr-black-overlay, #fowtr-chapter4 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl2.to("#fowtr-chapter4 #fowtr-article5 .card2 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);


      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article12", duration: 300})
        .setTween(tl2)
        .addTo(fowtr_module_chapter_4.controller);



      // animating the cards, third one enlarging

      var tl3 = new TimelineMax();

      tl3.to("#fowtr-chapter4 #fowtr-article5 .card1 h4, #fowtr-chapter4 #fowtr-article5 .card2 h4, #fowtr-chapter4 #fowtr-article5 a.card1, #fowtr-chapter4 #fowtr-article5 a.card2", 1, {color:'#ffffff', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter4 #fowtr-article5 .card3 h4, #fowtr-chapter4 #fowtr-article5 a.card3", 1, {color:'#ffcc00', ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter4 #fowtr-article5 .card1 .indicator, #fowtr-chapter4 #fowtr-article5 .card2 .indicator", 1, {borderBottomWidth:"0px", ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter4 #fowtr-article5 .card3 .indicator", 1, {borderBottomWidth:"10px", ease: Linear.easeNone}, 0);

      tl3.to("#fowtr-chapter4 #fowtr-article5 .card1 .fowtr-black-overlay, #fowtr-chapter4 #fowtr-article5 .card2 .fowtr-black-overlay", 1, {opacity:0.9, ease: Linear.easeNone}, 0);
      tl3.to("#fowtr-chapter4 #fowtr-article5 .card3 .fowtr-black-overlay", 1, {opacity:0.7, ease: Linear.easeNone}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article22", duration: 300})
        .setTween(tl3)
        .addTo(fowtr_module_chapter_4.controller);



      // animating the cards, ending, fadeout

      var tl4 = new TimelineMax();

      tl4.to("#fowtr-chapter4 #fowtr-article5", 1, {autoAlpha:0, display:'none', ease: Power2.easeInOut}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article28", duration: 300})
        .setTween(tl4)
        .addTo(fowtr_module_chapter_4.controller);








      // ------------------------------------------------------------------------------------------------------
      // article 7 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article7 .fowtr-parallax-bg').css({
        'top':'-42%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article7", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article7 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 8 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article8 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article8", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article8 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 9 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article9 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article9", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article9 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);








      // ------------------------------------------------------------------------------------------------------
      // article 10 - slider
      // ------------------------------------------------------------------------------------------------------


      if(!fowtr_module_utilities.isMobile){
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector1').data('powertip', 'Most Vulnerable Roles').powerTip();
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector2').data('powertip', 'Least Vulnerable Roles').powerTip();
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector3').data('powertip', 'Roles Generated by Automation').powerTip();
      }


      fowtr_module_chapter_4.slider = tns({
        container: '#fowtr-chapter4 #fowtr-article10 .fowtr-slider',
        items: 1,
        controls: false,
        nav: false,
        autoHeight: true,
      });

      // previous button
      $('#fowtr-chapter4 #fowtr-article10').on('click', '.slider-prev', function(event) {
        event.preventDefault();
        fowtr_module_chapter_4.slider.goTo('prev');
        jumpToTop();
      });

      // next button
      $('#fowtr-chapter4 #fowtr-article10').on('click', '.slider-next', function(event) {
        event.preventDefault();
        fowtr_module_chapter_4.slider.goTo('next');
        jumpToTop();
      });

      // click selector icon, go to slide
      $('#fowtr-chapter4 #fowtr-article10 .chart-selector').on('click', '.selector', function(event) {
        event.preventDefault();
        var index = $(this).attr('data-slide-index');
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector').removeClass('active');
        $(this).addClass('active');
        fowtr_module_chapter_4.slider.goTo(index);
        jumpToTop();
      });

      // update icon active on slider change
      fowtr_module_chapter_4.slider.events.on('indexChanged', function(info, eventName) {
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector').removeClass('active');
        $('#fowtr-chapter4 #fowtr-article10 .chart-selector .selector[data-slide-index="'+(info.index-1)+'"]').addClass('active');
      });


      // pinning

      var articleHeight = $('#fowtr-chapter4 #fowtr-article10').height();
      // pinning the section
      var sixSegmentsSelector = new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article10 .chart-selector-wrapper", triggerHook:'onLeave'})
        .setPin("#fowtr-chapter4 #fowtr-article10 .chart-selector-wrapper")
        .on('update', function () {
          // ugly hack to detect if its full header, minimal header, fullscreen etc.
          if($('#fowtr-wrapper').hasClass('fowtr-fullscreen')) {
            sixSegmentsSelector.offset(-50 -52); // -57 is cause of the 3 cards
          } else {
            if($(window).width()<768){
              sixSegmentsSelector.offset(-56 - 50 -52);
            } else {
              sixSegmentsSelector.offset(-108 - 50 -52);
            }
          }
        })
        .setClassToggle("#fowtr-chapter4 #fowtr-article10 .chart-selector-wrapper", 'pinned')
        .addTo(fowtr_module_chapter_4.controller);




      var tl5 = new TimelineMax();

      tl5.to("#fowtr-chapter4 #fowtr-article10 .chart-selector-wrapper", 1, {autoAlpha:0, display:'none', ease: Linear.easeNone}, 0);

      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article10", triggerHook:'onLeave', duration: 100, offset: articleHeight - 450})
        .setTween(tl5)
        .addTo(fowtr_module_chapter_4.controller);


      function jumpToTop(){
        var articleRect = $("#fowtr-chapter4 #fowtr-article10")[0].getBoundingClientRect();
        if($("#fowtr-chapter4 #fowtr-article10 .chart-selector-wrapper").hasClass('pinned')) {
        // if(articleRect.top < 0) {
          var offset = $("#fowtr-chapter4 #fowtr-article10").offset();
          TweenMax.to($('html, body'),0.3,{scrollTop:offset.top - 75,ease:Power2.easeInOut});
        }
      }

      // ====================================================================
      // Make arrows fit center on page within a div even if half off screen
      // ====================================================================

      fowtr_module_chapter_4.fitSliderNav = function(){
        var article = $("#fowtr-chapter4 #fowtr-article10");
        var buttons = $("#fowtr-chapter4 #fowtr-article10 .slider-navigation");
        var articleRect = article[0].getBoundingClientRect();
        var windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        var offTop = articleRect.top;
        var offBottom = windowHeight - (articleRect.top + articleRect.height);
        var articleHeight = article.height();

        // exit if not in screen at all
        if((articleRect.top) > windowHeight) return;
        if((articleRect.top + articleHeight) < 0) return;

        var headerHeight = 119 + 52 + 50;
        if(windowWidth < 768){
          headerHeight = 56 + 50;
        }

        headerHeight = 50;

        var availableHeight =  articleHeight;
        var top = 0;

        if(offTop < 0) {
          availableHeight -= Math.abs(offTop);
          top += Math.abs(offTop);
        }
        if(offBottom < 0) {
          availableHeight -= Math.abs(offBottom);
        }

        // allow for header
        availableHeight -= headerHeight;
        top += headerHeight;

        if(offTop + articleHeight > 200){
          buttons.height(availableHeight+'px');
          buttons.css('top',top+'px');
        }

        // fit selectors
        var headerRect = $('#fowtr-navigation')[0].getBoundingClientRect();
        var headerHeight = headerRect.top + headerRect.height;
      };
      // fowtr_module_chapter_4.fitSliderNav();

      if(!fowtr_module_utilities.disableFancyStuff) {
        document.addEventListener('scroll', fowtr_module_chapter_4.fitSliderNav);
        document.addEventListener('resize', fowtr_module_chapter_4.fitSliderNav);
      } else {
        $("#fowtr-chapter4 #fowtr-article10 .slider-navigation").height($("#fowtr-chapter4 #fowtr-article10").height());
      }


      // END ARTICLE 10 ! :-o



      // ------------------------------------------------------------------------------------------------------
      // article 21 parallax and video
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article11 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article11", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article11 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);

      //create a new player instance (vmpro)
      if($('#fowtr-article11-video-container').length){

        function createPlayer() {
            var initPlayer = {
                success: function (playerApi) {
                    // playerApi.play();
                    // playerApi.toggleMute();
                    fowtr_module_analytics.c4_article11_video_Loaded(this);
                    var newExpandButton = $('<div data-fowtr-mi24-modal="fowtr-image-modal" data-mi-player-role="mi-btn-expand" class="align-both mipf mi-bp-expand mi-controls-btn controlbar__fullscreen mipf-expand-off" role="button" aria-label="Full screen" tabindex="0"> <span class="mi-icon mi-icon--medium mi-icon--green mi-expand-off-icon"> <svg focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"> <path d="M49.2,59c0,0.5-0.2,0.9-0.6,1.3L30.2,78.7l8,8c0.7,0.7,1.1,1.5,1.1,2.5s-0.3,1.8-1.1,2.5c-0.7,0.7-1.5,1.1-2.5,1.1H10.8 c-1,0-1.8-0.3-2.5-1.1s-1.1-1.5-1.1-2.5V64.3c0-1,0.3-1.8,1.1-2.5c0.7-0.7,1.5-1.1,2.5-1.1s1.8,0.3,2.5,1.1l8,8l18.4-18.4 c0.4-0.4,0.8-0.6,1.3-0.6c0.5,0,0.9,0.2,1.3,0.6l6.3,6.3C49,58.1,49.2,58.5,49.2,59z M92.5,11.1v24.9c0,1-0.3,1.8-1.1,2.5 c-0.7,0.7-1.5,1.1-2.5,1.1c-1,0-1.8-0.3-2.5-1.1l-8-8L60,48.8c-0.4,0.4-0.8,0.6-1.3,0.6c-0.5,0-0.9-0.2-1.3-0.6l-6.3-6.3 c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.5,0.2-0.9,0.6-1.3l18.4-18.4l-8-8c-0.7-0.7-1.1-1.5-1.1-2.5s0.3-1.8,1.1-2.5c0.7-0.7,1.5-1.1,2.5-1.1 h24.9c1,0,1.8,0.3,2.5,1.1C92.1,9.3,92.5,10.1,92.5,11.1z"></path> </svg> </span> <span class="mi-icon mi-icon--medium mi-icon--green mi-expand-on-icon"> <svg focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve"> <path d="M.433 15.692l3.88-3.88L3.026 10.6c-.59-.59-.172-1.6.663-1.6h4.375c.518 0 .936.42.936.938v4.374c0 .836-1.008 1.254-1.599.663l-1.213-1.287-3.88 3.879a.625.625 0 0 1-.884 0l-.991-.991a.625.625 0 0 1 0-.884zM17.567 2.308l-3.88 3.88L14.974 7.4c.59.59.172 1.6-.663 1.6H9.936A.936.936 0 0 1 9 8.062V3.689c0-.836 1.008-1.254 1.599-.663l1.213 1.288 3.88-3.88a.625.625 0 0 1 .884 0l.991.991a.625.625 0 0 1 0 .884z"></path> </svg> </span> </div>');

                    $('#fowtr-article11-video-container .controlbar__fullscreen').remove();
                    $('#fowtr-article11-video-container .mi-control-bar-buttons-container').append(newExpandButton);

                },
                parameters: {
                    configType: 'vmpro',
                    playerId: '2pxV6w3_yqLG3UqhPWd-Ns',
                    videoId: '6aZNHPpKbTCN9ckFuLfa7-',
                    apiUrl: '//d.video-cdn.net/play',
                    flashPath: '//e.video-cdn.net/v2/',
                    token: "***"
                }
            };
      
            VideoPlayer.Collection.addPlayerById('fowtr-article11-video-container', initPlayer);
        }
      
        //add the player
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//e.video-cdn.net/v2/embed.js';
        head.appendChild(script);
          
        script.onload = (function () {
            createPlayer();
        });

      }



      // ------------------------------------------------------------------------------------------------------
      // article 14 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article14 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article14", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article14 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 15 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article15 .fowtr-parallax-bg').css({
        'top':'-36%',
        'height':'80%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article15", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article15 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 16 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article16 .fowtr-parallax-bg').css({
        'top':'-36%',
        'height':'80%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article16", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article16 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 17 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article17 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article17", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article17 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 18 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article18 .fowtr-parallax-bg').css({
        // 'top':'-41%',
        'height':'60%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article18", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article18 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 19 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article19 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article19", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article19 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 20 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article20 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article20", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article20 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // // ------------------------------------------------------------------------------------------------------
      // // article 21 parallax
      // // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter4 #fowtr-article21 .fowtr-parallax-bg').css({
      //   'top':'-41%',
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article21", duration: "200%", triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter4 #fowtr-article21 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_4.controller);






      // ----------------------------------
      // digital diversity in the workplace
      // ----------------------------------
      //create a new player instance (vmpro)
      if($('#fowtr-article20-video-container').length){

        function createPlayer() {
            var initPlayer = {
                success: function (playerApi) {
                    // playerApi.play();
                    // playerApi.toggleMute();
                    fowtr_module_analytics.c4_article20_video_Loaded(this);
                    // $('#fowtr-article20-video-container .controlbar__fullscreen').unbind('click');
                    // setTimeout(function(){
                    //   // $('#fowtr-article20-video-container .controlbar__fullscreen').removeClass('mipf-expand-off');
                    //   // $('#fowtr-article20-video-container .mipf-expand-off').unbind('click');
                    //   // $('#fowtr-article20-video-container [data-mi-player-role="mi-btn-expand"]').removeClass('mipf-expand-off');
                    //   // $('#fowtr-article20-video-container [data-mi-player-role="mi-btn-expand"]').removeClass('controlbar__fullscreen');
                    // }, 10);
                    var newExpandButton = $('<div data-fowtr-mi24-modal="fowtr-image-modal" data-mi-player-role="mi-btn-expand" class="align-both mipf mi-bp-expand mi-controls-btn controlbar__fullscreen mipf-expand-off" role="button" aria-label="Full screen" tabindex="0"> <span class="mi-icon mi-icon--medium mi-icon--green mi-expand-off-icon"> <svg focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve"> <path d="M49.2,59c0,0.5-0.2,0.9-0.6,1.3L30.2,78.7l8,8c0.7,0.7,1.1,1.5,1.1,2.5s-0.3,1.8-1.1,2.5c-0.7,0.7-1.5,1.1-2.5,1.1H10.8 c-1,0-1.8-0.3-2.5-1.1s-1.1-1.5-1.1-2.5V64.3c0-1,0.3-1.8,1.1-2.5c0.7-0.7,1.5-1.1,2.5-1.1s1.8,0.3,2.5,1.1l8,8l18.4-18.4 c0.4-0.4,0.8-0.6,1.3-0.6c0.5,0,0.9,0.2,1.3,0.6l6.3,6.3C49,58.1,49.2,58.5,49.2,59z M92.5,11.1v24.9c0,1-0.3,1.8-1.1,2.5 c-0.7,0.7-1.5,1.1-2.5,1.1c-1,0-1.8-0.3-2.5-1.1l-8-8L60,48.8c-0.4,0.4-0.8,0.6-1.3,0.6c-0.5,0-0.9-0.2-1.3-0.6l-6.3-6.3 c-0.4-0.4-0.6-0.8-0.6-1.3c0-0.5,0.2-0.9,0.6-1.3l18.4-18.4l-8-8c-0.7-0.7-1.1-1.5-1.1-2.5s0.3-1.8,1.1-2.5c0.7-0.7,1.5-1.1,2.5-1.1 h24.9c1,0,1.8,0.3,2.5,1.1C92.1,9.3,92.5,10.1,92.5,11.1z"></path> </svg> </span> <span class="mi-icon mi-icon--medium mi-icon--green mi-expand-on-icon"> <svg focusable="false" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve"> <path d="M.433 15.692l3.88-3.88L3.026 10.6c-.59-.59-.172-1.6.663-1.6h4.375c.518 0 .936.42.936.938v4.374c0 .836-1.008 1.254-1.599.663l-1.213-1.287-3.88 3.879a.625.625 0 0 1-.884 0l-.991-.991a.625.625 0 0 1 0-.884zM17.567 2.308l-3.88 3.88L14.974 7.4c.59.59.172 1.6-.663 1.6H9.936A.936.936 0 0 1 9 8.062V3.689c0-.836 1.008-1.254 1.599-.663l1.213 1.288 3.88-3.88a.625.625 0 0 1 .884 0l.991.991a.625.625 0 0 1 0 .884z"></path> </svg> </span> </div>');
                    $('#fowtr-article20-video-container .controlbar__fullscreen').remove();
                    $('#fowtr-article20-video-container .mi-control-bar-buttons-container').append(newExpandButton);

                },
                parameters: {
                    configType: 'vmpro',
                    playerId: '-N3ADm94paXTetMqHq1vgU',
                    videoId: '3KRHVL-m7iiPR8oP3kyeXw',
                    apiUrl: '//d.video-cdn.net/play',
                    flashPath: '//e.video-cdn.net/v2/',
                    token: "***"
                }
            };
      
            VideoPlayer.Collection.addPlayerById('fowtr-article20-video-container', initPlayer);
        }
      
        //add the player
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = '//e.video-cdn.net/v2/embed.js';
        head.appendChild(script);
          
        script.onload = (function () {
            createPlayer();
        });

      }




      // align-both mipf mi-bp-expand mi-controls-btn controlbar__fullscreen mipf-expand-off
      // $('#fowtr-wrapper').on('click', '.controlbar__fullscreen.mipf-expand-off', function(event) {
      //   event.preventDefault();
      //   console.log('expand');
      //   $('.fowtr-modal-overlay').fadeIn();

      //   // console.log(container.parent()[0]);
      //   var container = $(this).closest('.fowtr-mi24-video');
      //   // container.parent().find('.fowtr-mi24-modal-overlay').fadeIn();
      //   container.addClass('expanded');
      // });
























      // ------------------------------------------------------------------------------------------------------
      // article 23 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article23 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article23", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article23 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);



      // ------------------------------------------------------------------------------------------------------
      // article 24 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article24 .fowtr-parallax-bg').css({
        'top':'-41%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article24", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article24 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);


      // ------------------------------------------------------------------------------------------------------
      // article 25 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article25 .fowtr-parallax-bg').css({
        'top':'-30%',
        'height':'72%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article25", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article25 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);

      // ------------------------------------------------------------------------------------------------------
      // article 26 parallax
      // ------------------------------------------------------------------------------------------------------
      $('#fowtr-chapter4 #fowtr-article26 .fowtr-parallax-bg').css({
        'top':'-29%',
        'height':'70%',
      });
      new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article26", duration: "200%", triggerHook: "onEnter"})
              .setTween("#fowtr-chapter4 #fowtr-article26 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
              .addTo(fowtr_module_chapter_4.controller);

      // ----------------------------
      // image slider
      // ----------------------------

      // if(!fowtr_module_utilities.isMobile){
      //   $('#fowtr-chapter4 #fowtr-article26 .fowtr-slider-container').data('powertip', 'Click to enlarge image').powerTip();
      // }


      fowtr_module_chapter_4.imageSlider = tns({
        container: '#fowtr-chapter4 #fowtr-article26 .fowtr-slider',
        items: 1,
        controls: false,
        nav: false,
        // autoHeight: true,
      });

      // previous button
      $('#fowtr-chapter4 #fowtr-article26').on('click', '.slider-prev', function(event) {
        event.preventDefault();
        fowtr_module_chapter_4.imageSlider.goTo('prev');
        // jumpToTop();
      });

      // next button
      $('#fowtr-chapter4 #fowtr-article26').on('click', '.slider-next', function(event) {
        event.preventDefault();
        fowtr_module_chapter_4.imageSlider.goTo('next');
        // jumpToTop();
      });

      // update icon active on slider change
      // fowtr_module_chapter_4.imageSlider.events.on('indexChanged', function(info, eventName) {
      //   console.log('slided');
      // });






      // // ------------------------------------------------------------------------------------------------------
      // // article 27 parallax
      // // ------------------------------------------------------------------------------------------------------
      // $('#fowtr-chapter4 #fowtr-article27 .fowtr-parallax-bg').css({
      //   'top':'-41%',
      // });
      // new ScrollMagic.Scene({triggerElement: "#fowtr-chapter4 #fowtr-article27", duration: "200%", triggerHook: "onEnter"})
      //         .setTween("#fowtr-chapter4 #fowtr-article27 > .fowtr-parallax-bg", {y: "100%", ease: Linear.easeNone})
      //         .addTo(fowtr_module_chapter_4.controller);






      // ------------------------------------------------------------------------------------------------------
      // article 28 click icon and survey
      // ------------------------------------------------------------------------------------------------------
      var element = $("#fowtr-chapter4 #fowtr-article28 .fowtr-signup .click_icon");
      var article28signupclasses = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article28signupclasses); //put same classes on the new content
        var tl = new TimelineMax({repeat:-1});
        tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
      });

      var element = $("#fowtr-chapter4 #fowtr-article28 .fowtr-survey .click_icon");
      var article28classes = element.attr('class');
      fowtr_module_utilities.inlineSvg(element,function(svg){
        svg.attr('class',article28classes); //put same classes on the new content
        var tl = new TimelineMax({repeat:-1});
        tl.fromTo(svg.find('#ring'),2,{x:"-=0%",y:"-=0%",scale:1,opacity:1},{x:"-=7px",y:"-=8px",scale:2,opacity:0,ease:Power4.easeOut},0);
      });








      // ===================
      // popup
      // ===================
      // setTimeout(function(){
      //   console.log('popup');
      //   fowtr_module_modals.openPopup('fowtr-popup-workshop');
      // },2000);

      if(!fowtr_module_chapter_4.popupWorkshopViewed){
        $('#fowtr-chapter4 #fowtr-article20').on('inview', function(event, visible) {
          // console.log('opening fowtr-popup-workshop popup');

          if(fowtr_module_chapter_4.popupWorkshopViewed==false) {

            if((fowtr_module_read_aloud.isPlaying==true && fowtr_module_read_aloud.autoScroll==false) || fowtr_module_read_aloud.isPlaying==false){

              fowtr_module_modals.openPopup('fowtr-popup-workshop');
              
              // analytics
              // fowtr_module_analytics.tracking_adobe('Tour or Workshop Request','Popup','View','First');
              // fowtr_module_analytics.tracking_decibel('Tour or Workshop Request','Popup','View','First');

              fowtr_module_chapter_4.popupWorkshopViewed = true;
              // if (visible) {
                
              // } else {
              //   // hidden
              // }
            }
          }
        });
      }










      // survey / Usabilla



      // set up as a SPA
      // window.usabilla_live('virtualPageView');

      // button handler
      $('#fowtr-chapter4 #fowtr-article28 .fowtr-survey').click(function(event) {
        event.preventDefault();
        try {
          window.usabilla_live('trigger', 'fow_survey_trigger');
          $(this).addClass('disabled');
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      });

      // event callback
      try {
        resetUsabilla();
        window.usabilla_live('setEventCallback', function(category, action, label, value, userData){
          console.log('setEventCallback',action);
          if(action === "Campaign:Success" || action === "Campaign:Close") {
            resetUsabilla();
          }
        });
      } catch(e) {
        console.warn('usabilla_live not found');
      }


      // usbl.b2d2adfa16cf.c.d5cf372bcc76


      function resetUsabilla(){
        try {
          var arr = [];
          for (var i = 0; i < localStorage.length; i++){
            if (localStorage.key(i).substring(0,18) == 'usbl.b2d2adfa16cf.') {
              arr.push(localStorage.key(i));
            }
          }
          for (var i = 0; i < arr.length; i++) {
            localStorage.removeItem(arr[i]);
          }
        } catch(e) {
          console.warn('usabilla_live not found');
        }
      }


      // $(window).unload(function() {
      //   resetUsabilla();
      // });
      resetUsabilla();
      $(window).on('beforeunload', function(){
        resetUsabilla();
      });







      // // PUT SECTION ID MARKERS ON ALL ARTICLES
      // // $.each($('#fowtr-chapter4 article > div'), function(index, val) {
      // $.each($('#fowtr-chapter4 article > div[id^="fowtr-article"], #fowtr-chapter4 article .scrollmagic-pin-spacer > div[id^="fowtr-article"]'), function(index, val) {
      //    var id = $(this).attr('id');
      //    if(id){
      //     id = id.replace('fowtr-article','');
      //     console.log('article',id);
      //     var marker = $('<div style="background:magenta;color:white;position: absolute;top: 50%;left: 0;transform: rotate(-90deg);transform-origin: top left;padding: 10px;">Section <strong>'+id+'</strong></div>');
      //     $('#fowtr-article'+id).append(marker);
      //    }
      // });



      // if(fowtr_module_utilities.disableFancyStuff) tl.progress(1, false);
      // if(fowtr_module_utilities.disableFancyStuff) tl2.progress(1, false);
      // if(fowtr_module_utilities.disableFancyStuff) tl3.progress(1, false);
      // if(fowtr_module_utilities.disableFancyStuff) tl4.progress(1, false);
      // if(fowtr_module_utilities.disableFancyStuff) tl5.progress(1, false);








    };//end init function






    fowtr_module_chapter_4.destroy = function(chapter){
      
      console.log('destroy chapter '+chapter);
      document.removeEventListener('scroll', fowtr_module_chapter_4.fitSliderNav);
      document.removeEventListener('resize', fowtr_module_chapter_4.fitSliderNav);

    };//end destroy function




    return fowtr_module_chapter_4;
}(fowtr_module_chapter_4 || {}));

